import type { Product } from '@commerce/types/product'

const getFirstOpSize = (
  product: Product,
  variantSettings: {
    metal: string
    diam_type: string
    tcw: string
    size: string
  },
  currentFilters: string[],
  vl: string
) => {
  const filterByMetal = product?.variants
    ?.map((vr) => vr.options)
    .filter((vrn) => {
      const vn = vrn.filter((v) => v.displayName === 'Metal')[0]
      return vn ? vn.values[0].label === variantSettings.metal : false
    })

  const filterByType = currentFilters.includes('diam_type')
    ? filterByMetal.filter((vrn) => {
        const vn = vrn.filter((v) => v.displayName === 'Diamond Type')[0]
        return vn ? vn.values[0].label === variantSettings.diam_type : false
      })
    : filterByMetal

  const filterByTCW = currentFilters.includes('tcw')
    ? filterByType.filter((vrn) => {
        const vn = vrn.filter((v) => v.displayName === 'Total Carat Weight')[0]
        return vn ? vn.values[0].label === vl : false
      })
    : filterByType

  return Array.from(
    new Set(
      filterByTCW.map((vnt) => {
        const vn = vnt.filter((v) => v.displayName === 'Size')[0]
        return vn ? vn.values[0].label : ''
      })
    )
  ).filter((v) => v !== '')[0]
}

const decimalToFraction = (num: number) => {
  const integer = Math.trunc(num)
  let decimal = 100 / ((num - integer) * 10)
  if (decimal >= 100 || decimal <= 0) return num

  return `${integer !== 0 ? integer : ''} 1/${
    Math.trunc(decimal).toString().split('0')[0]
  }`
}

export { getFirstOpSize, decimalToFraction }
